import { stringify } from 'qs';
import { getTransactionFiltersFromSearchApiFilter } from '@Shared/helpers/dataMappers/filterMappers';
import { Api as apiService } from '../api';
export class TransactionsApi {
    static searchTransactions(params) {
        const query = stringify(params);
        return apiService.responseToJSONAndToastError(apiService.get(TransactionsApi.transactionsApiURL + `/search?${query}`));
    }
    static searchTransactionsTotals(params) {
        const query = stringify(params);
        return apiService.responseToJSONAndToastError(apiService.get(TransactionsApi.transactionsApiURL + `/search/totals?${query}`));
    }
    static searchCombinedTransactions(section, params) {
        const query = stringify(params);
        return apiService.responseToJSONAndToastError(apiService.get(TransactionsApi.transactionsApiURL + `/combined/${section}?${query}`));
    }
    static getTransactionsTotals(section, params) {
        const query = stringify(params);
        return apiService.responseToJSONAndToastError(apiService.get(TransactionsApi.transactionsApiURL + `/combined/${section}/totals?${query}`));
    }
    static approve(expenseId) {
        return apiService.responseToJSONAndToastError(apiService.post(TransactionsApi.transactionsApiURL + `/${expenseId}/approve?${TransactionsApi.includeWithExpenses}`));
    }
    static submit(payload) {
        return apiService.responseToJSONAndToastError(apiService.post('/api/web/card_transaction', payload));
    }
    static submitWithoutToastWrapper(payload) {
        return apiService.post('/api/web/card_transaction', payload);
    }
    static bulkSubmit(expenseDataList) {
        return apiService.responseToJSONAndToastError(apiService.post('/api/web/card_transaction/bulk_submit', { expense_data_list: expenseDataList }));
    }
    static queue(payload) {
        return apiService.responseWithToastError(apiService.post('/api/unsubmitted_expenses/queued', payload));
    }
    static queueWithoutToastWrapper(payload) {
        return apiService.post('/api/unsubmitted_expenses/queued', payload);
    }
    static unapprove(expenseId, data) {
        return apiService.responseToJSONAndToastError(apiService.put(TransactionsApi.transactionsApiURL + `/${expenseId}/reverse`, data));
    }
    static deny(expenseId, data) {
        return apiService.responseToJSONAndToastError(apiService.post(TransactionsApi.transactionsApiURL + `/${expenseId}/deny?${TransactionsApi.includeWithExpenses}`, data));
    }
    static deleteOne(expenseId) {
        return apiService.responseToJSONAndToastError(apiService.delete(TransactionsApi.transactionsApiURL + `/${expenseId}`));
    }
    static editAmount(expenseId, data) {
        return apiService.responseToJSONAndToastError(apiService.put(TransactionsApi.transactionsApiURL + `/${expenseId}/amount`, data));
    }
    static addComment(expenseId, message) {
        return apiService.responseToJSONAndToastError(apiService.post(`/api/web/transactions/${expenseId}/comment`, { message }));
    }
    static approveAll(body) {
        // The users of this method (ReimbursableExpenseBulkActions/TransactionsBulkActions) have their own error parsing/toasting behaviour
        // We shouldn't use responseToJSONAndToastError here
        return apiService.responseToJSON(apiService.post(TransactionsApi.transactionsApiURL + `/approveAll`, body));
    }
    static denyAll(body) {
        return apiService.responseToJSONAndToastError(apiService.post(TransactionsApi.transactionsApiURL + `/denyAll`, body));
    }
    static reassignAll(body) {
        return apiService.responseToJSONAndToastError(apiService.put(TransactionsApi.transactionsApiURL + `/manager/bulk/reassign`, body));
    }
    static getActivities(expenseId) {
        return apiService.responseToJSONAndToastError(apiService.get(`/api/web/transactions/${expenseId}/activity?include[user]`));
    }
    static getSplits(splitTransactionId) {
        return apiService.responseToJSONAndToastError(apiService.get(`/api/web/split_transactions/${splitTransactionId}`));
    }
    static getCombinedTransactions(params, tab, activeExpenseBucketsById, forPersonalCard) {
        var _a, _b;
        const searchParams = new URLSearchParams({
            limit: (_a = params.limit) === null || _a === void 0 ? void 0 : _a.toString(),
            offset: (_b = params.offset) === null || _b === void 0 ? void 0 : _b.toString(),
            include: JSON.stringify(['ocrReceipts', 'card'])
        });
        if (params.query) {
            searchParams.append('search', params.query.toString());
        }
        if (forPersonalCard) {
            searchParams.append('forPersonalCard', 'true');
        }
        if (params.sort) {
            searchParams.append('sortField', params.sort);
            searchParams.append('sortDirection', params.direction);
        }
        const filters = getTransactionFiltersFromSearchApiFilter(params.filters, activeExpenseBucketsById);
        if (filters) {
            searchParams.append('filters', JSON.stringify(filters));
        }
        return apiService.responseToJSONAndToastError(apiService.get(`/api/web/transactions/combined/${tab}?${searchParams}`));
    }
    static getUnexpensedTransactions(params, activeExpenseBucketsById) {
        return TransactionsApi.getCombinedTransactions(params, 'pending', activeExpenseBucketsById);
    }
    static skip(cardTransaction) {
        return apiService.responseToJSONAndToastError(apiService.post(`/api/web/accounts/cards/transactions/${cardTransaction.id}`, { status: 'skipped' }));
    }
    static unskip(cardTransaction) {
        return apiService.responseToJSONAndToastError(apiService.post(`/api/web/accounts/cards/transactions/${cardTransaction.id}`, { status: 'new' }));
    }
    static update(expense) {
        return apiService.responseToJSONAndToastError(apiService.put(`/api/web/transactions/${expense.id}`, expense));
    }
    static getAccountingSyncTransactions(params) {
        const query = stringify(params);
        return apiService.responseToJSONAndToastError(apiService.get(TransactionsApi.transactionsApiURL + `/accounting_sync_expenses?${query}`));
    }
    static bulkEditExpenses(expense_ids, changes) {
        return apiService.put(`/api/web/transactions/bulkedit`, { expense_ids, changes });
    }
}
TransactionsApi.transactionsApiURL = '/api/web/transactions';
TransactionsApi.includeWithExpenses = [
    'include[user]',
    'include[user_profile]',
    'include[venue_info]',
    'include[image]',
    'include[images]',
    'include[category]',
    'include[expense_tags]',
    'include[metadata]',
    'include[manager]',
    'include[card_transaction]',
    'include[card]',
    'include[trip]'
].join('&');
